<template>
  <div class="container py-6">

    <div class="title is-3">
      Welcome, {{ user.display_name }}
    </div>

    <div class="columns mt-5">

      <div class="column is-12 card">

        <div class="card-content">

          <div class="title-and-button mb-5">
            <div class="title is-5 mb-0">
              Announcement Board
            </div>

            <button 
              v-if="canEdit"
              @click="addingNew = true"
              class="button is-small is-primary">
              Add New
            </button>
          </div>

          <div class="masonry pb-3">

            <article 
              v-if="!loading && announcements.length == 0" 
              class="message is-info is-fullwidth">
              <div class="message-body">
                There are no announcements.
              </div>
            </article>

            <div 
              class="item card--outlined"
              v-for="announcement in announcements" 
              :key="announcement.id">

              <div 
                v-if="announcement.images" 
                @click="previewImage(announcement.images[0])"
                class="card-image">
                <figure class="image">
                  <template v-if="announcement.images && announcement.images[0]">
                    <img 
                      v-if="!announcement.images[0].includes('.mov')"
                      :src="announcement.images[0]" 
                      alt="Announcement image">
                    <video v-else controls>
                      <source 
                        :src="announcement.images[0]" 
                        type="video/mp4">
                    </video>
                  </template>
                  
                </figure>
              </div>

              <div class="card-content">
                <div class="content">
                  <span 
                    v-if="announcement.id != editingAnnouncement"
                    v-html="announcement.message">
                  </span>
                  <v-rich-text 
                    v-else
                    rows="3"
                    v-model="announcement.message">
                  </v-rich-text >
                </div>
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-32x32">
                      <img 
                        src="https://bulma.io/assets/images/placeholders/96x96.png" 
                        alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-6">
                      {{ announcement.created_user.display_name }}
                    </p>
                    <p class="subtitle is-7">
                      {{ formatDate(parse(announcement.created_on)) }}
                    </p>
                  </div>
                </div>
              </div>

              <footer class="card-footer" v-if="canEdit">
                <template v-if="announcement.id == editingAnnouncement">
                  <a 
                    @click="saveChanges(announcement)"
                    class="card-footer-item">
                    Save Edits
                  </a>
                  <a 
                    @click="editingAnnouncement = null"
                    class="card-footer-item">
                    Exit Editing
                  </a>
                </template>
                <template v-else>
                  <a 
                    class="card-footer-item"
                    @click="editingAnnouncement = announcement.id">
                    Edit
                  </a>
                  <a 
                    class="card-footer-item"
                    @click="deleteAnnouncement(announcement.id)">
                    Delete
                  </a>
                </template>
              </footer>
            </div>

          </div>

        </div>
      </div>
    </div>

    <add-announcement-modal v-model="addingNew"/>

    <v-file-preview
      v-model="previewing.status"
      :src="previewing.image"/>

  </div>
</template>

<script>
import VFilePreview from '@/components/base/VFilePreview'
import AddAnnouncementModal from '@/components/announcement/AddAnnouncementModal'
import VRichText from '@/components/base/VRichText'
import { mapState, mapActions } from 'vuex'
import { parseISO, format } from 'date-fns'

export default {
  components: { AddAnnouncementModal, VRichText, VFilePreview },
  data() {
    return {
      addingNew: false,
      editingAnnouncement: null,
      parse: (d) => {
        return d ? parseISO(d) : d
      },
      formatDate: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : d
      },
      previewing: {
        status: false,
        image: null
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("announcements", ["announcements", "loading"]),
    canEdit({ user }) {
      return ['office-manager', 'hr'].includes(user.role) || 
        user.permission == 'admin' || 
        user.permission == 'director';
    }
  },
  methods: {
    ...mapActions("announcements", [
      "getAnnouncements", "deleteAnnouncement", "updateAnnouncement"
    ]),
    initialize() {
      this.getAnnouncements();
    },
    saveChanges(announcement) {
      this.updateAnnouncement({ 
        announcementId: announcement.id, 
        data: { message: announcement.message } 
      }).then(() => {
        this.saving = false;
        this.editingAnnouncement = null;
      })
    },
    previewImage(src) {
      this.previewing.image = src;
      this.previewing.status = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/masonry.scss';

.card--outlined {
  border: 1px solid gainsboro;
  border-radius: 4px;
  .card-footer-item {
    padding: 0.5em;
  }
  .card-image {
    cursor: pointer;
  }
}

.title-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>